import { storeActions } from '@/store/actions'
import { NotificationState } from '@/store/notifications/notification'
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/react'
import { generateId } from '@repo/shared/uuid/uuid'

export function beneficiaryCases(
  builder: ActionReducerMapBuilder<NotificationState>,
) {
  builder
    .addCase(
      storeActions.beneficiary.create.fulfilled,
      (state, { payload: { beneficiary } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xCreated',
          descriptionTransOptions: { value: beneficiary.fullName },
          icon: 'check',
          id: generateId(),
        })
      },
    )
    .addCase(storeActions.beneficiary.chatSession.create.fulfilled, (state) => {
      state.all.push({
        createdAt: new Date().getTime(),
        descriptionTransKey: 'chatEnabled',
        icon: 'check',
        id: generateId(),
      })
    })
    .addCase(
      storeActions.beneficiary.update.fulfilled,
      (state, { payload: { beneficiary } }) => {
        state.all.push({
          createdAt: new Date().getTime(),
          descriptionTransKey: 'xUpdated',
          descriptionTransOptions: { value: beneficiary.fullName },
          icon: 'check',
          id: generateId(),
        })
      },
    )
}
